import Api from './ApiService'

export default {
    get(keyword, pageNumber, sort) {
        return Api().get(`users?keyword=${keyword}&pageNumber=${pageNumber}&sort=${sort}`);
    },
    getOne(id) {
        return Api().get(`users/${id}`);
    },
    create(data) {
        return Api().post(`users`, data);
    },
    updateUser(credentials){
        return Api().put(`users/update/user/${credentials.id}`, credentials);
    },
}